<template>
  <Layout>
    <LayoutMain>
      <slot />
    </LayoutMain>
  </Layout>
</template>
<script setup lang="ts"></script>
<style lang="scss"></style>
